import React, { useMemo } from 'react';
import { Box, ErrorModal, Inscription, Label, List, useResponsive } from '@common-fe/common-fe';
import styled from 'styled-components';

import PreviewPaymentDocument from '@/modules/transaction/components/TransactionDetails/TransactionPaymentDetails/components/PreviewPaymentDocument/PreviewPaymentDocument';

// import PreviewPaymentDocument from '../../TransactionDetails/components/TransactionPaymentDetails/components/PreviewPaymentDocument/PreviewPaymentDocument';

const getFileNameFromUrl = (url?: string) => {
  if (!url) return url;
  try {
    const { pathname } = new URL(url);
    return pathname.split('/').pop() || url;
  } catch {
    return url;
  }
};

const StyledLabel = styled(Label)`
  > div {
    min-width: 424px;
  }
`;

interface Props {
  fileUrl: string;
}

export const UploadProofFile: React.FC<Props> = ({ fileUrl }) => {
  const [errorMessage, setErrorMessage] = React.useState('');
  const [isDocPreviewModalVisible, setIsDocPreviewModalVisible] = React.useState(false);
  const { isMobile } = useResponsive();
  const fileName = useMemo(() => getFileNameFromUrl(fileUrl), [fileUrl]);

  return (
    <Box data-testId="UploadProofFile" direction="row" justify="between" align="center">
      {fileUrl ? (
        <Box direction="row">
          <Box width={{ min: '74px' }}>
            <PreviewPaymentDocument
              key={fileUrl}
              paymentDocumentPath={fileUrl}
              modalTitle="File Preview"
              isNumberOfImageHidden
              isDocPreviewModalVisible={isDocPreviewModalVisible}
              setIsDocPreviewModalVisible={setIsDocPreviewModalVisible}
            />
          </Box>
          <Box
            margin={{ left: 'spacing12', right: 'spacing12' }}
            justify="center"
          >
            <Inscription
              style={{ 
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              {fileName}
            </Inscription>
          </Box>
        </Box>
      ) : (
        <StyledLabel showRequireIcon isNarrow size="14px">
          Provide proof of the participant’s withdrawal request
          <Box margin={{ left: '-10px', top: 'spacing2' }} pad={{ right: 'spacing4' }}>
            <Inscription size="small" weight="normal" lineHeight="18px" color="textSecondary">
              PDF, HEIF, JPEG, JPG, PNG, TIFF
            </Inscription>
          </Box>
        </StyledLabel>
      )}

      <Box>
        {
          isMobile ? (
            <List.Item.Options testId="upload-proof-file-preview-tree-dots">
              <List.Item.Options.Item
                testId="upload-proof-file-preview"
                onClick={() => setIsDocPreviewModalVisible(true)}
              >
                Preview
              </List.Item.Options.Item>
            </List.Item.Options>
          ) : (
            <Inscription
              data-testid="upload-proof-file-preview"
              color="textAccent"
              onClick={() => setIsDocPreviewModalVisible(true)}
              style={{ cursor: 'pointer' }}
            >
              Preview 
            </Inscription>
          )
        }

      </Box>

      <ErrorModal
        testId="upload-proof-file-error-modal"
        header="Error"
        helpText={errorMessage}
        visible={Boolean(errorMessage)}
        onSetVisible={() => {
          setErrorMessage('');
        }}
        buttonText="Close"
      />
    </Box>
  );
};
